import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "variable-rate-tooltip-text" }

import { PropType, computed } from "vue";
import usePaymentOptions from "@/use/paymentOptions";
import Tooltip from "@/components/pel-loan-configuration/Tooltip.vue";
import Icon from "@/components/shared/Icon.vue";
import { RatePlanVM } from "@/models/loanConfiguration";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'VariableRateTooltip',
  props: {
  option: {
    type: Object as PropType<RatePlanVM>,
  },
},
  setup(__props) {

const store = useStore();

const { formatRatePercentages, formatStartOfQuarter } = usePaymentOptions();

const props = __props;

const coApplicantTypeDisplayName = computed<string>(() =>
  store.getters["coApplicantTypeDisplayName"]?.toLowerCase(),
);

const startOfQuarter = computed<string>(() => formatStartOfQuarter(props.option?.startOfQuarter));

const indexRate = computed(() =>
  props.option?.indexRate
    ? formatRatePercentages(props.option?.indexRate, 3)
    : props.option?.indexRate,
);

const margin = computed(() =>
  props.option?.margin ? formatRatePercentages(props.option?.margin, 3) : props.option?.margin,
);

const indexPublishDate = computed(() => props.option?.indexPublishDate);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tooltip, { class: "tooltip-wrapper right-auto" }, {
    toggle: _withCtx(() => [
      _createElementVNode("sup", null, [
        _createVNode(Icon, { icon: "info" })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("p", null, "Variable Rates", -1)),
        _createElementVNode("p", null, " Current offered rate is calculated using the Index, Margin and Floor value(s) in effect. Your specific Interest Rate, Margin, Floor, and/or credit approval depends upon the credit qualifications of the student borrower and " + _toDisplayString(coApplicantTypeDisplayName.value) + " (if applicable). ", 1),
        _createElementVNode("p", null, " The \"Index\" for the quarter beginning " + _toDisplayString(startOfQuarter.value) + " is " + _toDisplayString(indexRate.value) + ", which was the Prime index published in the Wall Street Journal on the first business day of " + _toDisplayString(indexPublishDate.value) + ". The credit approved margin is " + _toDisplayString(margin.value) + ". Floor and Ceiling will be disclosed at account opening. ", 1)
      ])
    ]),
    _: 1
  }))
}
}

})